// "No answer — text" on the lead drawer (12 Oct 2026). Jacky could not reach a HiPages customer by phone, so
// EmmA drafts the text that carries his free times and the customer's personal booking link. One call to
// EmmA's own route (ca-emma-api `POST /api/lead-response/first-replies/:lead_id/no-answer`, through the
// `/emma-lead-response/` door in nginx.conf.template and vite.config.ts) with the staff bearer. That route
// records the call attempt itself, so the drawer adds NO touch of its own — two clicks would be two attempts.
// The text is not sent here: it waits as a send_communication approval, the one click Jacky keeps.
export type NoAnswerItem = { lead_id: string; state: string; draft_id: string | null; send_case_id: string | null; body: string; slots?: unknown[]; link?: string | null };
export type NoAnswerResult = { ok: true; item: NoAnswerItem } | { ok: false; error: string };

export const noAnswerPath = (leadId: string) => `/emma-lead-response/first-replies/${encodeURIComponent(leadId)}/no-answer`;

/** Only a lead with a phone that can take a text gets the button. */
export function canTextNoAnswer(phone: string | null | undefined): boolean {
  return /^\+?\d{8,15}$/.test((phone ?? "").replace(/[\s()-]/g, ""));
}

/** EmmA's answer in one shape: 200 {ok,item} → the draft; anything else → her `error` sentence. */
export function readNoAnswer(status: number, body: unknown): NoAnswerResult {
  const b = (body ?? {}) as { ok?: unknown; item?: Partial<NoAnswerItem>; error?: unknown };
  if (status >= 200 && status < 300 && b.ok === true && b.item && typeof b.item.body === "string")
    return { ok: true, item: { lead_id: String(b.item.lead_id ?? ""), state: String(b.item.state ?? ""), draft_id: b.item.draft_id ?? null, send_case_id: b.item.send_case_id ?? null, body: b.item.body, slots: Array.isArray(b.item.slots) ? b.item.slots : [], link: b.item.link ?? null } };
  return { ok: false, error: typeof b.error === "string" && b.error.trim() ? b.error.trim() : `HTTP ${status}` };
}

export async function requestNoAnswer(leadId: string, headers: Record<string, string>, f: typeof fetch = fetch): Promise<NoAnswerResult> {
  const r = await f(noAnswerPath(leadId), { method: "POST", headers: { ...headers, "content-type": "application/json" }, body: "{}" });
  return readNoAnswer(r.status, await r.json().catch(() => null));
}
